import { Link } from "react-router-dom";
import PageHead from "@/components/site/PageHead";
import { Reveal } from "@/components/site/Motion";

const CONTENT = {
  privacy: {
    eyebrow: "Legal",
    title: ["Privacy", "Policy."],
    body: (
      <>
        <p>
          This page describes how T-EMRP collects, uses, and protects information submitted through this site — such as contact-form details — and, separately, how pilot-related operational data would be governed under the data-use agreements described in the Governance and Safety page.
        </p>
        <p>
          Contact-form submissions (name, title, organization, contact details, and message) are stored solely for the purpose of responding to your inquiry and scheduling briefings. They are not sold, shared with third parties, or used for marketing.
        </p>
        <p>
          A complete privacy policy will be finalized with legal review before public launch.
        </p>
      </>
    ),
  },
  terms: {
    eyebrow: "Legal",
    title: ["Terms", "of Use."],
    body: (
      <>
        <p>
          This page sets out the terms governing use of this website, including intellectual-property notices, disclaimers regarding the pre-pilot and proposed status of T-EMRP, and limitations of liability.
        </p>
        <p>
          T-EMRP is a proposed pilot framework in pre-pilot status. Nothing on this site constitutes clinical guidance, a credential, a partnership agreement, or a commitment by any party. It does not replace TECC, TCCC, NIMS, state EMS rules, local protocols, or a physician medical director.
        </p>
        <p>
          Complete terms of use will be finalized with legal review before public launch.
        </p>
      </>
    ),
  },
  accessibility: {
    eyebrow: "Legal",
    title: ["Accessibility", "Statement."],
    body: (
      <>
        <p>
          This site is designed to conform to the Web Content Accessibility Guidelines (WCAG) 2.2, Level AA. It aims to be fully responsive, keyboard-operable, and compatible with screen readers, with adequate color contrast, visible focus indicators, and respect for reduced-motion preferences.
        </p>
        <p>
          If you encounter an accessibility barrier on this site, please <Link to="/contact" className="text-signal hover:underline">contact us</Link> so it can be corrected.
        </p>
      </>
    ),
  },
};

export default function Legal({ page }) {
  const c = CONTENT[page];
  return (
    <main data-testid={`legal-page-${page}`}>
      <PageHead eyebrow={c.eyebrow} titleLines={c.title} />
      <section className="py-24 max-w-3xl mx-auto px-6 lg:px-10">
        <Reveal>
          <div className="space-y-6 text-slate-300 leading-relaxed text-sm [&_p]:leading-relaxed">
            {c.body}
          </div>
        </Reveal>
      </section>
    </main>
  );
}
